import { WorkoutMode } from '@kinomap-dev/ng-ui-lib/core';

/**
 * Identifiant numerique de chaque mode attendu par l'API (`mode`), repris du legacy (`sportModeList`).
 * Les ids sont propres a chaque sport mais un mode garde le meme id partout (`res` vaut 1 en
 * cycling, rowing et elliptical), le mode suffit donc a le determiner.
 */
export const WORKOUT_MODE_IDS: Readonly<Record<WorkoutMode, number>> = {
    res: 1,
    ftp: 2,
    slope: 4,
    watts: 5,
    inc: 1,
    spd: 2,
    incSpd: 3,
};
